import { mergeShopCategoryTrees } from '@/shein-platform/utils/sheinOfficialShopCategory';
import {
  normalizePlatformCode,
  shopTypeEquals,
} from '@/utils/platformShopCatalog';
import { sheinPlatformAPI, temuPlatformAPI, tiktokPlatformAPI } from '@/utils/api';

/** 当前账号下已真实授权、可用于类目筛选的店铺（排除模拟授权） */
export function isAuthorizedBoundShop(shop) {
  return !!shop
    && shop.authStatus === 'connected'
    && !!shop.realAuthBound
    && !shop.mockBinding;
}

/**
 * 解析类目筛选用的店铺集合：
 * - 指定店铺 → 仅该店
 * - 否则按平台 + 店铺类型收窄到已授权店，多店类目合并
 */
export function resolveShopsForCategoryFilter(authorizedShops, {
  shopId = '',
  shopType = '',
  platformCode = '',
} = {}) {
  let list = (Array.isArray(authorizedShops) ? authorizedShops : []).filter(isAuthorizedBoundShop);
  const platform = normalizePlatformCode(platformCode);
  if (platform) {
    list = list.filter((s) => normalizePlatformCode(s.platformCode) === platform);
  }

  const preferredId = String(shopId || '').trim();
  if (preferredId) {
    const hit = list.find((s) => String(s.id) === preferredId);
    return hit ? [hit] : [];
  }

  const type = String(shopType || '').trim();
  if (type) {
    list = list.filter((s) => shopTypeEquals(
      s.shopType,
      type,
      platform || normalizePlatformCode(s.platformCode) || 'SHEIN',
    ));
  }
  return list;
}

async function fetchShopCategoryTree(shop) {
  const sid = shop?.id;
  if (sid == null || sid === '') return [];
  const platform = normalizePlatformCode(shop.platformCode);
  const loader = platform === 'TEMU'
    ? temuPlatformAPI.getShopCategories(sid)
    : (platform === 'TIKTOK'
      ? tiktokPlatformAPI.getShopCategories(sid)
      : sheinPlatformAPI.getShopCategories(sid));
  try {
    const res = await loader;
    return res?.categories ?? res?.items ?? res?.list ?? res ?? [];
  } catch {
    return [];
  }
}

/**
 * 按已授权店铺加载并合并类目树（用户工作台用，不走 admin 全局类目）。
 * @param {Array<object>} shops
 * @returns {Promise<Array>}
 */
export async function loadMergedAuthorizedShopCategories(shops) {
  const list = (Array.isArray(shops) ? shops : []).filter((s) => s?.id != null && s.id !== '');
  if (!list.length) return [];
  const trees = await Promise.all(list.map((shop) => fetchShopCategoryTree(shop)));
  return mergeShopCategoryTrees(trees);
}
